import { Space, Tag } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { COURSE_OFFER_TYPES } from '../../utilities/constants';
import { getEnrolmentPercentage } from '../../utilities/courseEnrolment';
import TableWithSorter from '../Common/TableWithSorter';
import './CourseOffer.css';

const CourseOfferTable = (props) => {
  const data = props.data;
  const columns = [
    {
      title: 'ID',
      dataIndex: 'courseOfferId',
      key: 'courseOfferId',
      sorter: (a, b) => a.courseOfferId - b.courseOfferId,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Wave',
      dataIndex: 'wave',
      key: 'wave',
      sorter: (a, b) => a.wave - b.wave,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Group Number',
      dataIndex: 'groupNumber',
      key: 'groupNumber',
      sorter: (a, b) => a.groupNumber - b.groupNumber,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      sorter: (a, b) => a.code.localeCompare(b.code),
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => (
        <Space size="middle">
          <Link to={'/course-offer/' + record.courseOfferId}>{text}</Link>
        </Space>
      ),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Status',
      dataIndex: 'courseOfferStatus',
      key: 'courseOfferStatus',
      filters: [
        {
          text: 'Inactive',
          value: 'Inactive',
        },
        {
          text: 'Active',
          value: 'Active',
        },
        {
          text: 'Pending',
          value: 'Pending',
        },
      ],
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value, record) => record.courseOfferStatus === value,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      filters: [
        {
          text: 'live',
          value: COURSE_OFFER_TYPES.LIVE,
        },
        {
          text: 'Cohort Live',
          value: COURSE_OFFER_TYPES.COHORT_LIVE,
        },
        {
          text: 'Pre-recorded',
          value: COURSE_OFFER_TYPES.PRE_RECORDED,
        },
        {
          text: 'Cohort on-Demand',
          value: COURSE_OFFER_TYPES.COHORT_ON_DEMAND,
        },
        {
          text: 'Video on-Demand',
          value: COURSE_OFFER_TYPES.VIDEO_ON_DEMAND,
        },
      ],
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value, record) => record.type === value,
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
      sorter: (a, b) =>
        new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      sorter: (a, b) =>
        new Date(a.endDate).getTime() - new Date(b.endDate).getTime(),
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Enrolment Count',
      dataIndex: 'courseEnrolmentCount',
      key: 'courseEnrolmentCount',
      render: (value, item) => {
        const enrolmentPercent = getEnrolmentPercentage(
          value,
          item.maxRegistrations
        );
        let color = 'green';
        if (enrolmentPercent < 50) {
          color = 'red';
        } else if (enrolmentPercent >= 50 && enrolmentPercent < 100) {
          color = 'geekblue';
        }
        return (
          <div>
            <span style={{ marginRight: '5px' }}>
              {value}/{item.maxRegistrations}
            </span>
            <Tag color={color}>
              {enrolmentPercent} {enrolmentPercent !== 'Full' ? '%' : ''}
            </Tag>
          </div>
        );
      },
    },
  ];

  return (
    <div className="course-offer-table">
      <TableWithSorter
        rowClassName={(record) => {
          const enrolmentPercent = getEnrolmentPercentage(
            record.courseEnrolmentCount,
            record.maxRegistrations
          );
          let className = 'full-enrolment-row';
          if (enrolmentPercent < 50) {
            className = 'low-enrolment-row';
          } else if (enrolmentPercent >= 50 && enrolmentPercent < 100) {
            className = 'high-filling-enrolment-row';
          }
          return className;
        }}
        tableLayout="auto"
        scroll={{ x: 1000 }}
        expandable={{ defaultExpandAllRows: true }}
        dataSource={data}
        columns={columns}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30'],
        }}
      />
    </div>
  );
};

export default CourseOfferTable;
